export function permissionGroups(groups = [], changes = {}) {
  return groups.map((group) => {
    const tools = group.tools.map((tool) => ({ ...tool, tier: changes[tool.slug] ?? tool.tier }))
    const allowedCount = tools.filter((tool) => tool.tier === 'allow').length
    return {
      ...group,
      tools,
      allowedCount,
      approvalCount: tools.length - allowedCount,
    }
  })
}
